<script setup lang="ts">
  import RadioQC from '@qicgroupdoha/qic-connect-ds/components/RadioQC'
  import { GENDERS } from '@/shared/constants/other.constants'

  interface Props {
    modelValue: number
    disabled: boolean
    ocrIsAvailable: boolean
    loading: boolean
  }

  defineProps<Props>()
  defineEmits<{ (e: 'update:modelValue', value: number): void }>()
</script>

<template>
  <div
    class="radio-container"
    :class="{ 'radio-container--paddings': !ocrIsAvailable }"
  >
    <!-- @vue-ignore -->
    <RadioQC
      v-if="!disabled || modelValue === GENDERS.MALE"
      :model-value="modelValue"
      :value="GENDERS.MALE"
      :disabled="disabled"
      :container-attrs="{ 'data-test': 'gender-male-radio' }"
      :variant="ocrIsAvailable ? 'mini' : 'default'"
      :loading="loading"
      data-test="gender-male-radio-inner"
      @update:model-value="$emit('update:modelValue', $event)"
    >
      {{ $t('qic_user_male') }}
    </RadioQC>

    <!-- @vue-ignore -->
    <RadioQC
      v-if="!disabled || modelValue === GENDERS.FEMALE"
      :model-value="modelValue"
      :value="GENDERS.FEMALE"
      :disabled="disabled"
      :container-attrs="{ 'data-test': 'gender-female-radio' }"
      :variant="ocrIsAvailable ? 'mini' : 'default'"
      :loading="loading"
      data-test="gender-female-radio-inner"
      @update:model-value="$emit('update:modelValue', $event)"
    >
      {{ $t('qic_user_female') }}
    </RadioQC>
  </div>
</template>

<style lang="scss" scoped>
  .radio-container {
    display: flex;
    gap: var(--spacing-7);
  }
  .radio-container--paddings {
    padding-block: calc(var(--spacing-4) + var(--spacing-2));
  }
</style>
